import { Impresa } from '../models/impresa';

export const nonCrifKeys: Readonly<(keyof Impresa)[]> = [
  'dataInizioAttivita',
  'prefisso',
  'telefono',
  'iban',
  'intestatarioIban',
  'numeroDipendenti',
  'email',
  'pecAggiuntiva',
  'documentazioneNumeroDipendenti',
];
